import React from 'react'
import {
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from '@material-ui/core'
export default function AdditionalDateInput({fieldFor, data, onChange = (e, key, value) => {}}) {
  let dateCalculationOptions = [
    {name: 'Add', value: 'add'},
    {name: 'Subtract', value: 'sub'},
  ]
  return (
    <>
      <FormControl variant="outlined" className="ap-textfield" style={{width: 93, marginTop: 16}}>
        <InputLabel id=""></InputLabel>
        <Select
          labelId=""
          id=""
          //defaultValue={'add'}
          value={data.op}
          onChange={(e, value) => onChange(e, fieldFor, value, 'op')}
          style={{width: '93px'}}
        >
          {dateCalculationOptions.map(opt => {
            return <MenuItem value={opt.value}>{`${opt.name}`}</MenuItem>
          })}
        </Select>
      </FormControl>
      <TextField
        variant="outlined"
        id="standard-number"
        label="Days"
        type="number"
        value={data?.days}
        onChange={(e, value) => onChange(e, fieldFor, value, 'days')}
        InputLabelProps={{
          shrink: true,
        }}
        inputProps={{min: 0}}
        className="ap-textfield"
        style={{width: 76, marginTop: 16}}
      />
      <TextField
        variant="outlined"
        id="standard-number"
        label="Months"
        type="number"
        inputProps={{min: 0}}
        value={data?.months}
        onChange={(e, value) => onChange(e, fieldFor, value, 'months')}
        InputLabelProps={{
          shrink: true,
        }}
        className="ap-textfield"
        style={{width: 76, marginTop: 16}}
      />
      <TextField
        variant="outlined"
        id="standard-number"
        label="Years"
        type="number"
        inputProps={{min: 0}}
        value={data?.years}
        onChange={(e, value) => onChange(e, fieldFor, value, 'years')}
        InputLabelProps={{
          shrink: true,
        }}
        className="ap-textfield"
        style={{width: 76, marginTop: 16}}
      />
    </>
  )
}
